import type React from 'react';
import classes from './change-password-page.module.scss';
import { useChangePasswordPageController } from './useChangePasswordPageController';

export const ChangePasswordPage: React.FC = () => {
  const {
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    isLoading,
    onSubmit,
  } = useChangePasswordPageController();

  return (
    <div className={`profilePage ${classes.passwordPage}`} dir="rtl">
      <header className="profilePageHeader">
        <div>
          <h1>שינוי סיסמה</h1>
          <p>בחרו סיסמה חדשה וחזקה לחשבון שלכם</p>
        </div>
      </header>
      <section className={`profilePanel ${classes.passwordPanel}`}>
        <div className="profilePanelHeader">
          <h2>פרטי אבטחה</h2>
        </div>
        <form className={classes.passwordForm} onSubmit={onSubmit}>
          <div className="profileField">
            <label htmlFor="currentPassword">סיסמה נוכחית</label>
            <input
              id="currentPassword"
              type="password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete="current-password"
            />
          </div>
          <div className="profileField">
            <label htmlFor="newPassword">סיסמה חדשה</label>
            <input
              id="newPassword"
              type="password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div className="profileField">
            <label htmlFor="confirmPassword">אימות סיסמה חדשה</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
            />
          </div>
          <button className="profileSaveButton" type="submit" disabled={isLoading}>
            {isLoading ? 'שומר...' : 'עדכון סיסמה'}
          </button>
        </form>
      </section>
    </div>
  );
};
